import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// See useDccBridgeAccess. Export has no server-side counterpart, so this hook is the only gate.
function useExportAccess() {
  const premiumFeatures = useThreeDStudioStore((state) => state.subscription.premiumFeatures)
  return premiumFeatures === true
}

export default useExportAccess
